<template>
  <div class="MuiBottomNavigation-root menuBar" style="position: fixed;width: 100%;bottom:-1px;z-index: 999;">
  <min-sale />
    <div class="form-group " style="margin-top:0;margin-bottom: 0; width: 100%;">
      <button class="MuiButtonBase-root btn MuiBottomNavigationAction-root bg-light" @click="changeActive('btn1');" type="button" style="border-bottom-left-radius:0;border-top-left-radius:0;border-bottom-right-radius:0;width: 33%;">
        <router-link class="router-link-class " :to="{ name: 'Home' }">
          <span class="MuiBottomNavigationAction-wrapper">
            <span class="MuiBottomNavigationAction-label1 btn1 " style="color: black "><i class="bi bi-house fa-btn1"
                aria-hidden="true" style="color: black !;display:block;font-size: 1.1em;"></i>خانه</span>
          </span>
          <span class="MuiTouchRipple-root"></span>
        </router-link>
      </button>
      <button @click="changeActive('btn2');" data-bs-toggle="modal" data-bs-target="#MenuModal" class="MuiButtonBase-root btn  MuiBottomNavigationAction-root bg-light" type="button" style="color: black;border-radius: 0;width: 34%">
        <span class="MuiBottomNavigationAction-wrapper ">
          <span class="MuiBottomNavigationAction-label1 ">
            <i class="bi bi-grid fa-btn2" aria-hidden="true" style="color: black;display:block;font-size: 1.1em;"></i>
            <span class="btn2" style="white-space: nowrap">
              دسته بندی
            </span>
          </span>
        </span>
        <span class="MuiTouchRipple-root"></span>
      </button>
      <button @click="changeActive('btn3');" id="basketHeaderNav" class="MuiButtonBase-root btn  MuiBottomNavigationAction-root bg-light position-relative" type="button" style="color: black;border-bottom-right-radius:0;border-bottom-left-radius:0;border-top-right-radius:0;width: 33%">
        <!-- <label-temp></label-temp> -->
        <span class="MuiBottomNavigationAction-wrapper ">
          <span class="MuiBottomNavigationAction-label1">
            <i class="bi bi-receipt  fa-btn3" aria-hidden="true"
              style="color: black;display:block;font-size: 1.1em;"></i>
            <span class="btn3" style="white-space: nowrap">
               سفارشات
            </span>
          </span>
        </span>
        <span class="MuiTouchRipple-root"></span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import LabelTemp from '../item/labelTemp.vue';
import MinSale from './MinSale.vue';
import { useBasket } from '@/store/basket';
import { useAuth } from '@/store/auth';
import { alertBox } from '@/composables/silverBox';
let storeBasket = useBasket()
let auth = useAuth()
const router = useRouter()
function changeActive(item) {
  const buttons = document.querySelectorAll('.btn1, .fa-btn1, .btn2, .fa-btn2, .btn3, .fa-btn3');
  buttons.forEach(button => button.classList.remove('active'));
  if (item == 'btn3') {
    // سفارشات
    if(auth.login){
      router.push({ name: 'orders' ,hash:'#orders'})
    }else{
      alertBox('این گزینه پس از ورود به سایت در دسترس است.','info')
    }
    document.querySelector('.btn3').classList.add('active')
    document.querySelector('.fa-btn3').classList.add('active')
    setTimeout(() => {
      document.querySelector('.btn3').classList.remove('active')
      document.querySelector('.fa-btn3').classList.remove('active')
    }, 1000);

  }
  if (item == 'btn2') {
    // دسته بندی
    document.querySelector('.btn2').classList.toggle('active')
    document.querySelector('.fa-btn2').classList.toggle('active')
    setTimeout(() => {
      document.querySelector('.btn2').classList.remove('active')
      document.querySelector('.fa-btn2').classList.remove('active')
    }, 500);
  }
  if (item == 'btn1') {
    // خانه
    document.querySelector('.btn1').classList.add('active')
    document.querySelector('.fa-btn1').classList.add('active')
    if(document.getElementById('MenuModalCloseBTN')){
      document.getElementById('MenuModalCloseBTN').click()
    }
    if(document.getElementById("sliderModalBTN")){
      document.getElementById("sliderModalBTN").click()
    }
    window.scroll({
      top : 0,
      behavior : 'auto'
    })
  }
}
</script>

<style scoped>
.MuiBottomNavigationAction-label1 {
  font-size: 12px;
  font-weight: 600;
  opacity: 1;
  transition: font-size 0.2s, opacity 0.2s;
  transition-delay: 0.1s;
}
.active {
  color: rgb(230, 52, 98) !important;
  font-size: 13px !important;
  font-weight: bold;

}
a {
  color: black;
}
button {
  background-color: #fff;
  border: none;

}
button:hover,
button:active,
button:focus {
  background-color: #fff;
}
</style>